import { Link } from "react-router-dom";
import { ArrowUpRight, Mail, MapPin, Phone } from "lucide-react";
import { LogoMark } from "./Logo";

const NAV = [
  { label: "Home", href: "#top" },
  { label: "Products", href: "#products" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

const LEGAL = [
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms of Service", to: "/terms" },
  { label: "Refund Policy", to: "/refund-policy" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-white/[0.06] pt-16 pb-10">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div className="max-w-sm">
          <div className="flex items-center gap-2.5">
            <LogoMark size={28} />
            <span className="font-display text-lg font-600 text-white">ArcaCentum</span>
          </div>
          <p className="mt-4 text-sm text-white/45 font-light">
            AI Technology &amp; Software Products
          </p>
          <p className="mt-6 text-sm text-white/35 font-light leading-relaxed">
            Building the intelligence layer for the next generation of software.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <span className="text-[11px] uppercase tracking-[0.2em] text-white/30 mb-1">Navigate</span>
          {NAV.map((l) => (
            <a key={l.label} href={l.href} data-testid={`footer-link-${l.label.toLowerCase()}`}
              className="text-sm text-white/60 hover:text-white transition-colors duration-300">
              {l.label}
            </a>
          ))}
          <Link to="/help" data-testid="footer-link-help-center"
            className="text-sm text-white/60 hover:text-white transition-colors duration-300">
            Help Center
          </Link>
          <a href="https://arcacentum.ai" target="_blank" rel="noopener noreferrer" data-testid="footer-link-arcacentumai"
            className="group inline-flex items-center gap-1 text-sm text-white/60 hover:text-white transition-colors duration-300">
            ArcaCentum.ai
            <ArrowUpRight size={13} className="text-violet-300 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>

        <div className="flex flex-col gap-3">
          <span className="text-[11px] uppercase tracking-[0.2em] text-white/30 mb-1">Legal</span>
          {LEGAL.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm text-white/60 hover:text-white transition-colors duration-300">
              {l.label}
            </Link>
          ))}
        </div>

        <div className="flex flex-col gap-3">
          <span className="text-[11px] uppercase tracking-[0.2em] text-white/30 mb-1">Company</span>
          <a href="mailto:support@arcacentum.com" data-testid="footer-support-email"
            className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white transition-colors duration-300">
            <Mail size={13} className="text-cyan-300" /> support@arcacentum.com
          </a>
          <span className="inline-flex items-start gap-2 text-sm text-white/45 font-light leading-relaxed" data-testid="footer-address">
            <MapPin size={13} className="text-cyan-300 mt-1 shrink-0" />
            <span>ArcaCentum, Inc.<br />2654 W Horizon Ridge Pkwy<br />Ste B5 #2338<br />Henderson, NV 89052, United States</span>
          </span>
          <a href="tel:+18889775190" data-testid="footer-phone"
            className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white transition-colors duration-300">
            <Phone size={13} className="text-cyan-300" /> (888) 977-5190
          </a>
        </div>
      </div>

      <hr className="hairline my-10" />

      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/30">
        <span>© {new Date().getFullYear()} ArcaCentum, Inc. All rights reserved.</span>
        <span className="font-light">An AI technology company · ArcaCentum.com</span>
      </div>
    </div>
  </footer>
);
